import {MapService} from '../../../Services/map/MapService';
import {MapConfigurationService} from '../../../Services/map/MapConfigurationService';

export interface SetMapCenterRequest {
  latitude: number;
  longitude: number;
  zoom?: number;
}

export interface SetMapCenterResponse {
  center: { lat: number; lng: number };
  bounds: {
    sw: { lat: number; lng: number };
    ne: { lat: number; lng: number };
  };
  zoom: number;
}

export class SetMapCenterUseCase {
  constructor (
    private mapService: MapService,
    private configService: MapConfigurationService
  ) {}

  execute (request: SetMapCenterRequest): SetMapCenterResponse {
    const {latitude, longitude, zoom} = request;
    const config = this.configService.getConfiguration();

    // التحقق من صحة الإحداثيات
    if (!this.mapService.validateCoordinates(latitude, longitude)) {
      throw new Error(`Invalid coordinates: lat=${latitude}, lng=${longitude}`);
    }

    // تعيين الزوم المناسب
    const finalZoom = zoom ?? config.defaultZoom;

    // حساب الحدود الجديدة
    const bounds = this.mapService.calculateBounds(
      {lat: latitude, lng: longitude},
      finalZoom
    );


    return {
      center: {lat: latitude, lng: longitude},
      bounds: {
        sw: {lat: bounds.sw.lat, lng: bounds.sw.lng},
        ne: {lat: bounds.ne.lat, lng: bounds.ne.lng}
      },
      zoom: finalZoom
    };
  }

  setCityCenter (cityName: string): SetMapCenterResponse {
    const city = this.configService.getCityByName(cityName);

    if (!city) {
      throw new Error(`City "${cityName}" not found in configuration`);
    }

    return this.execute({
      latitude: city.lat,
      longitude: city.lng,
      zoom: this.configService.getConfiguration().defaultZoom
    });
  }
}
